<template>
    <div>
        <label class="styled-form__label">{{ label }}</label>
        <span
                :class="['styled-form__error', {'is-visible': errorLocal}]"
                style="float: right;"
        >{{ errorLocal }}</span>
        <datepicker
                id="register-date-picker"
                initial-view="year"
                input-class="styled-form__input"
                placeholder="Select date"
                @input="changeHandler"
                calendar-button-icon="fa fa-calendar"
                name="date"
                :value="value"
                :disabledDates="disabledDates"
                :format="customFormatter"
        ></datepicker>
        <div class="styled-form__field">
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker'

    export default {
        components: {
            Datepicker
        },
        props: {
            value: {
                required: true
            },
            label: String,
            error: String
        },
        data() {
            return {
                datePicker: {
                    start: moment().subtract(115, 'years').toDate(),
                    finish: moment().subtract(1, 'days').toDate()
                },
                disabledDates: {
                    to: moment().subtract(114, 'years').toDate(),
                    from: moment(new Date()).toDate()
                },
                errorLocal: ''
            };
        },
        computed: {
            datePickerClass() {
                return this.errorLocal ? 'styled-form__date-picker is-invalid' : 'styled-form__date-picker';
            }
        },
        watch: {
            error: function(value) {
                this.errorLocal = value ? value : '';
                this.setInputClass();
            }
        },
        methods: {
            changeHandler(newValue) {
                this.validateDateOfBirth(newValue);

                let parsedValue = '';
                if (newValue !== '') {
                    parsedValue = moment(newValue).format('YYYY-MM-DD');
                }
                this.$emit('input', parsedValue);
            },
            validateDateOfBirth(dateOfBirth) {
                let invalidYearsAgo = moment().subtract(115, 'years');
                if (!moment(dateOfBirth, 'YYYY-MM-DD').isValid()) {
                    this.errorLocal = 'This field is required';
                } else if (moment(dateOfBirth, 'YYYY-MM-DD').diff(moment(new Date())) > 0
                    || moment(dateOfBirth, 'YYYY-MM-DD').diff(invalidYearsAgo, 'years') <= 0) {
                    this.errorLocal = 'Enter a valid date of birth';
                } else {
                    this.errorLocal = '';
                }
                this.setInputClass();
            },
            setInputClass() {
                let inputEl = document.getElementById('register-date-picker');
                if (this.errorLocal.length) {
                    if (!inputEl.classList.contains('is-invalid')) {
                        inputEl.classList.add('is-invalid');
                    }
                } else {
                    if (inputEl.classList.contains('is-invalid')) {
                        inputEl.classList.remove('is-invalid');
                    }
                }
            },
            customFormatter(date) {
                return moment(date).format('DD MMM YYYY'); 
            }
        }
    };
</script>
